import { React, useState, useEffect, useRef } from 'react'
import { Toast } from 'antd-mobile'
import { useNavigate, useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LeftOutline } from 'antd-mobile-icons'
import data from '../utils/phone'
import './area.css'
import axios from 'axios'
import { basciUrl } from "../request/defaultURL";

export default function Area() {
  const { t, i18n } = useTranslation();
  const [datas, setDatas] = useState([])
  const [filteredDatas, setFilteredDatas] = useState([]) // ✅ 筛选后的列表
  const [value, setValue] = useState('')
  const location = useLocation();
  let navigate = useNavigate();
  const [type, setType] = useState('')
  console.log();
  useEffect(() => {
    setType(location.state)
    getList()
  }, [])
  const getList = () => {
    let loadId = Toast.show({
      icon: 'loading',
      content: t('t4'),
    })
    axios({
      url: basciUrl + "/api/getCountry",
      params: {}
    }).then(res => {
      if (res.data.code == 1) {
        setDatas(res.data.data)
        setFilteredDatas(res.data.data) // ✅ 初始化时也赋值给筛选数组
      }
      loadId.close()
    }).catch(err => { loadId.close() })
  }
  const itemClick = (val) => {
    if (type == 1) {
      navigate('/Login', { state: val })
    } else {
      navigate('/Register', { state: val })
    }
  }
  const confirmVal = () => {
    if (value == '') {
      Toast.show({
        icon: 'fail',
        content: t('t24'),
      })
    }
    if (type == 1) {
      navigate('/Login', { state: value })
    } else {
      navigate('/Register', { state: value })
    }
  }
  // ✅ 筛选逻辑
  const handleInputChange = (e) => {
    const inputVal = e.target.value
    setValue(inputVal)
    if (inputVal.trim() === '') {
      setFilteredDatas(datas) // 输入为空时恢复原列表
    } else {
      const filter = datas.filter(item =>
        item.code.toString().includes(inputVal) ||  // 按区号匹配
        (item.name && item.name.toLowerCase().includes(inputVal.toLowerCase())) // 按国家名匹配
      )
      setFilteredDatas(filter)
    }
  }
  return (
    <div>
      <div className='fixed_header'>
        <div className='backIcon' onClick={() => { navigate(-1) }}>
          <LeftOutline />
        </div>
        <p>{t('qy1')}</p>
      </div>
      <div className='area_box'>
        <div className='input_area'>
          <p>+</p>
          <input type="number" value={value || ""} onChange={handleInputChange} />
          <p onClick={confirmVal}> {t('ty1')} </p>
        </div>
        <div className='area_list'>
          {
            filteredDatas.map((item, index) => {
              return (
                <div key={index} className="area_item" onClick={() => { itemClick(item.code) }}>
                  <img src={item.pic} alt="" />
                  <p>+{item.code} {item.name}</p>
                </div>
              )
            })
          }
        </div>
      </div>
    </div >
  )
}
